import React from "react";
import { Table, Input } from "reactstrap";
import { useEffect, useState } from "react";
import axios from "axios";
import VendorDocumentRow from "../components/VendorDocumentRow";



const VendorInfoTabs = ({
    selectedVendor,
    vendorFiles,
    files,
    isEditing,
    setIsEditing,
    handleInputChange,
    subTab,
    setSubTab,
    type,
}) => {
    const isVendor = type === "vendor";

    const [invoiceData, setInvoiceData] = useState([]);

    useEffect(() => {
        if (subTab === "details" && type === "invoice") {
            fetchInvoiceList();
        }
    }, [subTab, type]);

    const fetchInvoiceList = async () => {
        try {
            const response = await axios.get("/api/invoices/list");
            setInvoiceData(response.data);
        } catch (error) {
            console.error("Error fetching invoice list:", error);
        }
    };

    return (
        <>
            {/* Tabs */}
            <div className="tabs2">
                <span
                    className={subTab === "details" ? "active-tab" : ""}
                    onClick={() => setSubTab("details")}
                >
                    Details
                </span>
                <span
                    className={subTab === "other" ? "active-tab" : ""}
                    onClick={() => setSubTab("other")}
                >
                    Other Details
                </span>
            </div>

            <div className="info-container">
                {/* DETAILS TAB */}
                {subTab === "details" && (
                    <Table bordered className="info-table">
                        <tbody>
                            <tr>
                                <td>Company Name</td>
                                <td>{isEditing ? <Input value={selectedVendor.legalName || ""} onChange={(e) => handleInputChange(e, "legalName")} /> : (selectedVendor.legalName || selectedVendor.nameOfCompany)}</td>                                <td>Contact Person</td>
                                <td>{isEditing ? <Input value={selectedVendor.contactPersonName || ""} onChange={(e) => handleInputChange(e, "contactPersonName")} /> : selectedVendor.contactPersonName}</td>
                            </tr>
                            <tr>
                                <td>Email ID</td>
                                <td>{isEditing ? <Input value={selectedVendor.email || ""} onChange={(e) => handleInputChange(e, "email")} /> : (selectedVendor.email || selectedVendor.emailId)}</td>                                <td>Contact number</td>
                                <td>{isEditing ? <Input value={selectedVendor.telephone || ""} onChange={(e) => handleInputChange(e, "telephone")} /> : selectedVendor.telephone}</td>
                            </tr>
                            <tr>
                                <td>Address</td>
                                <td>{isEditing ? <Input value={selectedVendor.address3 || ""} onChange={(e) => handleInputChange(e, "address3")} /> : (selectedVendor.address3 || selectedVendor.address)}</td>                                <td>Supplier Type</td>
                                <td>{isEditing ? <Input value={selectedVendor.natureOfSupply || ""} onChange={(e) => handleInputChange(e, "natureOfSupply")} /> : selectedVendor.natureOfSupply}</td>
                            </tr>
                            <tr>
                                <td>Nature of Supply</td>
                                <td>{isEditing ? (
                                    <Input type="select" value={selectedVendor.natureOfSupply || ""} onChange={(e) => handleInputChange(e, "natureOfSupply")}>
                                        <option value="">Select</option>
                                        <option value="Goods">Goods</option>
                                        <option value="Services">Services</option>
                                    </Input>
                                ) : selectedVendor.natureOfSupply}</td>
                            </tr>

                            <tr>
                                <td>Create Date</td>
                                <td>{isEditing ? <Input type="date" value={selectedVendor.startDate || ""} onChange={(e) => handleInputChange(e, "startDate")} /> : selectedVendor.startDate}</td>
                                <td>Vendor Code</td>
                                <td>{isEditing ? <Input value={selectedVendor.vendorCode || ""} onChange={(e) => handleInputChange(e, "vendorCode")} /> : selectedVendor.vendorCode}</td>
                            </tr>
                            <tr>
                                <td>Business Reg No</td>
                                <td>{isEditing ? <Input value={selectedVendor.businessRegNo || ""} onChange={(e) => handleInputChange(e, "businessRegNo")} /> : selectedVendor.businessRegNo}</td>
                                <td>Start Date</td>
                                <td>{isEditing ? <Input type="date" value={selectedVendor.startDate || ""} onChange={(e) => handleInputChange(e, "startDate")} /> : selectedVendor.startDate}</td>
                            </tr>

                            <tr>
                                <td>Short Name</td>
                                <td>{isEditing ? <Input value={selectedVendor.shortName || ""} onChange={(e) => handleInputChange(e, "shortName")} /> : selectedVendor.shortName}</td>
                                <td>Legal Name</td>
                                <td>{isEditing ? <Input value={selectedVendor.legalName || ""} onChange={(e) => handleInputChange(e, "legalName")} /> : selectedVendor.legalName}</td>
                            </tr>
                            <tr>
                                <td>Address</td>
                                <td colSpan={3}>
                                    {isEditing ? (
                                        <div style={{ display: "flex", gap: "10px" }}>
                                            <Input
                                                value={selectedVendor.address2 || ""}
                                                onChange={(e) => handleInputChange(e, "address2")}
                                                placeholder="Address Line 1"
                                                style={{ flex: 1 }}
                                            />
                                            <Input
                                                value={selectedVendor.address3 || ""}
                                                onChange={(e) => handleInputChange(e, "address3")}
                                                placeholder="Address Line 2"
                                                style={{ flex: 1 }}
                                            />
                                        </div>
                                    ) : (
                                        <div style={{ display: "flex", gap: "20px" }}>
                                            <span>{selectedVendor.address2 || "N/A"}</span>
                                            <span>{selectedVendor.address3 || "N/A"}</span>
                                        </div>
                                    )}
                                </td>
                            </tr>
                            <tr>
                                <td>City</td>
                                <td>{isEditing ? <Input value={selectedVendor.city || ""} onChange={(e) => handleInputChange(e, "city")} /> : selectedVendor.city}</td>
                                <td>State</td>
                                <td>{isEditing ? <Input value={selectedVendor.state || ""} onChange={(e) => handleInputChange(e, "state")} /> : selectedVendor.state}</td>
                            </tr>
                            <tr>
                                <td>Country</td>
                                <td>{isEditing ? <Input value={selectedVendor.country || ""} onChange={(e) => handleInputChange(e, "country")} /> : selectedVendor.country}</td>
                                <td>Zip/Postal Code</td>
                                <td>{isEditing ? <Input type="number" value={selectedVendor.postalCode || ""} onChange={(e) => handleInputChange(e, "postalCode")} /> : selectedVendor.postalCode}</td>
                            </tr>
                            <tr>
                                <td>Telephone</td>
                                <td>{isEditing ? <Input type="number" value={selectedVendor.telephone || ""} onChange={(e) => handleInputChange(e, "telephone")} /> : selectedVendor.telephone}</td>
                                <td>Fax</td>
                                <td>{isEditing ? <Input value={selectedVendor.fax || ""} onChange={(e) => handleInputChange(e, "fax")} /> : selectedVendor.fax}</td>
                            </tr>
                            <tr>
                                <td>Email ID</td>
                                <td>{isEditing ? <Input value={selectedVendor.email || ""} onChange={(e) => handleInputChange(e, "email")} /> : selectedVendor.email}</td>
                                <td>Website</td>
                                <td>{isEditing ? <Input value={selectedVendor.website || ""} onChange={(e) => handleInputChange(e, "website")} /> : selectedVendor.website}</td>
                            </tr>
                        </tbody>
                    </Table>
                )}

                {/* OTHER DETAILS TAB */}
                {subTab === "other" && (
                    <Table bordered className="info-table">
                        <tbody>
                            <tr>
                                <td>Bank Name</td>
                                <td>
                                    {isEditing ? (
                                        <Input
                                            value={selectedVendor.bankName || ""}
                                            onChange={(e) => handleInputChange(e, "bankName")}
                                        />
                                    ) : (
                                        selectedVendor.bankName
                                    )}
                                </td>
                                <td>Branch Name</td>
                                <td>
                                    {isEditing ? (
                                        <Input
                                            value={selectedVendor.branchName || ""}
                                            onChange={(e) => handleInputChange(e, "branchName")}
                                        />
                                    ) : (
                                        selectedVendor.branchName
                                    )}
                                </td>
                            </tr>

                            <tr>
                                <td>IFSC Code</td>
                                <td>
                                    {isEditing ? (
                                        <Input
                                            value={selectedVendor.ifscCode || ""}
                                            onChange={(e) => handleInputChange(e, "ifscCode")}
                                        />
                                    ) : (
                                        selectedVendor.ifscCode
                                    )}
                                </td>
                                <td>Account Number</td>
                                <td>
                                    {isEditing ? (
                                        <Input
                                            value={selectedVendor.accountNumber || ""}
                                            onChange={(e) => handleInputChange(e, "accountNumber")}
                                        />
                                    ) : (
                                        selectedVendor.accountNumber
                                    )}
                                </td>
                            </tr>

                            {/* Vendor Documents Row */}
                            <VendorDocumentRow
                                vendorId={selectedVendor.vendorId || selectedVendor.id} // ✅ fallback
                                files={files}
                            //{/*files={vendorFiles}*/}
                                isEditing={isEditing}
                            />

                            <tr>
                                <td>HSN/SAC Code</td>
                                <td>
                                    {isEditing ? (
                                        <Input
                                            value={selectedVendor.hsNsacCode || ""}
                                            onChange={(e) => handleInputChange(e, "hsNsacCode")}
                                        />
                                    ) : (
                                        selectedVendor.hsNsacCode
                                    )}
                                </td>
                                <td>Beneficiary Name</td>
                                <td colSpan={3}>
                                    {isEditing ? (
                                        <Input
                                            value={selectedVendor.beneficiaryName || ""}
                                            onChange={(e) => handleInputChange(e, "beneficiaryName")}
                                        />
                                    ) : (
                                        selectedVendor.beneficiaryName
                                    )}
                                </td>
                            </tr>

                            <tr>
                                <td>Vendor Regi MSME</td>
                                <td>{selectedVendor.ISMSME === 1 ? "Yes" : "No"}</td>
                                <td>MSME No</td>
                                <td>
                                    {isEditing ? (
                                        <Input
                                            value={selectedVendor.msmeNo || ""}
                                            onChange={(e) => handleInputChange(e, "msmeNo")}
                                        />
                                    ) : (
                                        selectedVendor.msmeNo || "N/A"
                                    )}
                                </td>
                            </tr>

                            <tr>
                                <td>Revenue</td>
                                <td>
                                    {isEditing ? (
                                        <Input
                                            type="number"
                                            value={selectedVendor.revenue || ""}
                                            onChange={(e) => handleInputChange(e, "revenue")}
                                            placeholder="Enter annual revenue"
                                        />
                                    ) : selectedVendor.revenue ? (
                                        Number(selectedVendor.revenue).toLocaleString("en-IN")
                                    ) : (
                                        "0"
                                    )}
                                </td>
                                <td>Investment</td>
                                <td>
                                    {isEditing ? (
                                        <Input
                                            type="number"
                                            value={selectedVendor.investment || ""}
                                            onChange={(e) => handleInputChange(e, "investment")}
                                            placeholder="Enter total investment"
                                        />
                                    ) : selectedVendor.investment ? (
                                        Number(selectedVendor.investment).toLocaleString("en-IN")
                                    ) : (
                                        "0"
                                    )}
                                </td>
                            </tr>
                        </tbody>
                    </Table>
                )}

                {/* Save button */}
                {isEditing && (
                    <div className="text-center mt-3">
                        <button className="save-btn" onClick={() => setIsEditing(false)}>
                            Save
                        </button>
                    </div>
                )}
            </div>
        </>
    );
};

export default VendorInfoTabs;